import { getFeatures } from 'pricing-pages-lib/api/FeaturesApi';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { FEATURES } from './constants/RequestedDataTypes';
export const FetchFeaturesRequestTypes = createRequestTypes(FEATURES);
export const FetchFeatureActions = createRequestActions(FetchFeaturesRequestTypes);
export const fetchFeatures = ({
  highlightedProducts,
  productLine
}) => {
  return makeFetchRequest({
    requestActions: FetchFeatureActions,
    fetch: getFeatures,
    payload: {
      highlightedProducts,
      productLine
    }
  });
};